export reducer from './reducer'


/** WEBPACK FOOTER **
 ** ./src/app/modules/mediaType/index.js
 **/